import axios from "../../../config/axiosConfig";

export const getResumenMes = ({ year, mes }) =>
  axios.get("/api/reporte-cierre/resumen-mes", { params: { year, mes } });

export const getHistorialAnio = ({ year }) =>
  axios.get("/api/reporte-cierre/historial-anio", { params: { year } });

export const cerrarMes = ({ year, mes }) =>
  axios.post("/api/reporte-cierre/cerrar-mes", { year, mes });
